
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'

import {edit} from '@/base/js/api'
export default {
name: 'app',
data() {
return {
isBtn:false,
date:'',
gender:'',
genders:'',
isGenders: false,
realname:'',
userInfo:'',
wxInfo:'',
menus2: {
menu1:'男',
menu2: '女'
},
}
},
components: {
Actionsheet,
PopupPicker
},
created(){
this.wxInfo=this._wxTool.getUser();
this.userInfo = this._wxTool.getMember();

this.genders =this.menus2[`menu${this.userInfo.gender}`]
console.log(this.genders)
this.realname = this.userInfo.realname
this.date = this.userInfo.buycarTime
},
methods: {
genderElect() {
this.isGenders = !this.isGenders
},
click (key,val) {
console.log(key,val)
this.genders = val
this.isBtn = true
},
keepBtn(){
if(this.realname == ''){
this.$vux.toast.text('请输入姓名','middle')
return
}
if(!this.$TelText(this.userInfo.phone)){
this.$vux.toast.text('您输入的手机号有误', 'middle')
return
}
if(this.genders == ''){
this.$vux.toast.text('请填写性别', 'middle')
return
}
if(this.buycarTime == ''){
this.$vux.toast.text('请输入正确的购车日期', 'middle')
return
}
if(this.genders=='男'){
this.gender = 1
}else if(this.genders == '女'){
this.gender = 2
}else{
this.gender = 0
}
let param = {
accessToken:this._wxTool.getAccessToken(),
realname:this.realname,
phone:this.phone,
gender:this.gender.toString(),
buycarTime:this.date,
company:this.userInfo.company
}
console.log(param)
edit(param).then(res=>{
console.log(res)
if(res.code == 0){
console.log(res);
this.$vux.toast.text('保存成功', 'middle')
this._wxTool.getMember(true);
this.isBtn = !this.isBtn;
}else{
this.$vux.toast.text(res.msg, 'middle')
}
})
},
inputChange(){
this.isBtn = true
},
dateChange(e) {
let _this =this
this.$vux.datetime.show({
value: '2018-09-13', // 其他参数同 props
title:'购车日期',
confirmText:'确定',
cancelText:'取消',
onConfirm (val) {
console.log('plugin confirm', val)
_this.date=val
this.isBtn = true
},
onHide () {
const _this = this
},
onShow () {
const _this = this
}
})



},
}
}



// WEBPACK FOOTER //
// ./src/pages/my/personalInfo/personalInfo.vue